import { render, staticRenderFns } from "./RemoteFileSelectAboutBox.vue?vue&type=template&id=f4239cfa"
import script from "./RemoteFileSelectAboutBox.vue?vue&type=script&lang=ts"
export * from "./RemoteFileSelectAboutBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports